var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.render = function () {
        var _a = this.props, data = _a.data, renderItem = _a.renderItem, keyExtractor = _a.keyExtractor;
        return (React.createElement("div", { style: wrapper }, data.map(function (item) { return (React.createElement("div", { key: keyExtractor(item) }, renderItem(item))); })));
    };
    return Grid;
}(Component));
export default Grid;
var wrapper = {
    display: 'grid',
    gridTemplateColumns: '200px 200px 200px',
    gridGap: '10px',
    backgroundColor: '#fff',
    color: '#444',
    margin: '40px'
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Grid.tsx
// module id = 1039
// module chunks = 0